import React from 'react';
import {withRouter} from "../withRouter";
import {NavLink} from "react-router-dom";
import {Container} from "react-bootstrap";
import GameChats from "../Chat/GameChats";
import Subscriptions from "../Subscribe/Subscriptions";

class Profile extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        var content = <section style={{backgroundColor: "#eee"}}>
            <div className="container py-5">
                <div className="row">
                    <div className="col">
                        <nav aria-label="breadcrumb" className="bg-light rounded-3 p-3 mb-4">
                            <ol className="breadcrumb mb-0">
                                <li className="breadcrumb-item active" aria-current="page">User Profile</li>
                                {this.props.user.role === 'admin' ? <li className="breadcrumb-item"><a href="/admin">
                                    <button type="button" className="btn btn-primary">Admin panel</button>
                                </a>
                                </li> : <span></span>}
                                {this.props.user.role === 'moderator' ? <li className="breadcrumb-item"><a href="/moderator">
                                    <button type="button" className="btn btn-primary">Moderator panel</button>
                                </a>
                                </li> : <span></span>}
                                {this.props.user.role === 'publisher' ? <li className="breadcrumb-item">
                                    <a href="/developer/console">
                                        <button type="button" className="btn btn-dark ms-1">Developer Console</button>
                                    </a>
                                </li> : <span></span>}
                            </ol>
                        </nav>
                    </div>
                </div>

                <div className="row">
                    <div className="col-lg-4">
                        <div className="card mb-4">
                            <div className="card-body text-center">
                                <img src={this.props.user.icon ? this.props.user.icon : "https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-chat/ava3.webp"}
                                     alt="avatar"
                                     className="rounded-circle img-fluid" style={{width: '150px;'}}/>
                                    <h5 className="my-3">{this.props.user.first_name} {this.props.user.last_name}</h5>
                                    <p className="text-muted mb-1">{this.props.user.role}</p>
                                    <div className="d-flex justify-content-center mb-2">
                                        <a href="/account/manage">
                                            <button type="button" className="btn btn-primary">Manage account</button>
                                        </a>
                                        <a href="/logout">
                                            <button type="button" className="btn btn-outline-primary ms-1">Log out</button>
                                        </a>

                                    </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm">
                                <center><h5>Subscriptions</h5></center>
                                <Subscriptions loadGames={false} userId={this.props.user.id}/>
                            </div>
                            <div className="col-sm">
                                <center><h5>Downloads</h5></center>
                                <div className="card mb-4 mb-lg-0">
                                    <div className="card-body p-0">
                                        <ul className="list-group list-group-flush rounded-3">
                                            {this.props.downloads.map(item => (
                                                <li className="list-group-item d-flex justify-content-between align-items-center p-3">
                                                    <i className="fab fa-github fa-lg" style={{color: "#333333"}}></i>
                                                    <p className="mb-0">
                                                        <NavLink
                                                            to={"/games/" + item.game_id}
                                                            class="btn btn-outline-success"
                                                            style={{
                                                                textDecoration: "none"
                                                            }}
                                                        >
                                                            {item.game.name}
                                                            <br/>
                                                            <img width="80" style={{
                                                                borderRadius: 5
                                                            }} src={item.game.game_page ? item.game.game_page.icon_url : "#"}></img>
                                                        </NavLink>
                                                    </p>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-sm">
                                <center><h5>Library</h5></center>
                                <div className="card mb-4 mb-lg-0">
                                    <div className="card-body p-0">
                                        <ul className="list-group list-group-flush rounded-3">
                                            {this.props.library.map(item => (
                                                <li className="list-group-item d-flex justify-content-between align-items-center p-3">
                                                    <i className="fab fa-github fa-lg" style={{color: "#333333"}}></i>
                                                    <p className="mb-0">
                                                        <NavLink
                                                            to={"/games/" + item.game_id}
                                                            class="btn btn-outline-success"
                                                            style={{
                                                                textDecoration: "none"
                                                            }}
                                                        >
                                                            {item.game.name}
                                                            <br/>
                                                            <img width="80" style={{
                                                                borderRadius: 5
                                                            }} src={item.game.game_page ? item.game.game_page.icon_url : "#"}></img>
                                                        </NavLink>
                                                    </p>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm">
                                <center><h5>Favourites</h5></center>
                                <div className="card mb-4 mb-lg-0">
                                    <div className="card-body p-0">
                                        <ul className="list-group list-group-flush rounded-3">
                                            {this.props.favourites.map(item => (
                                                <li className="list-group-item d-flex justify-content-between align-items-center p-3">
                                                    <i className="fab fa-github fa-lg" style={{color: "#333333"}}></i>
                                                    <p className="mb-0">
                                                        <NavLink
                                                            to={"/games/" + item.game_id}
                                                            class="btn btn-outline-success"
                                                            style={{
                                                                textDecoration: "none"
                                                            }}
                                                        >
                                                            {item.game.name}
                                                            <br/>
                                                            <img width="80" style={{
                                                                borderRadius: 5
                                                            }} src={item.game.game_page ? item.game.game_page.icon_url : "#"}></img>
                                                        </NavLink>
                                                    </p>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div className="col-lg-8">
                        <div className="card mb-4">
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-sm-3">
                                        <p className="mb-0">Full Name</p>
                                    </div>
                                    <div className="col-sm-9">
                                        <p className="text-muted mb-0">{this.props.user.first_name} {this.props.user.last_name}</p>
                                    </div>
                                </div>
                                <hr/>
                                <div className="row">
                                    <div className="col-sm-3">
                                        <p className="mb-0">Email</p>
                                    </div>
                                    <div className="col-sm-9">
                                        <p className="text-muted mb-0">{this.props.user.email}</p>
                                    </div>
                                </div>
                                <hr/>
                                <div className="row">
                                    <div className="col-sm-12">
                                        <p className="text-muted mb-0">
                                            <div>
                                                <button className="btn btn-outline-primary" id='chat-open-button' onClick={(e) => {
                                                    let block = document.getElementById('chat');

                                                    if (block.style.display === 'none') {
                                                        block.style.display = 'block';
                                                    } else {
                                                        block.style.display = 'none';
                                                    }
                                                }}>Your chats
                                                </button>
                                                <div style={{display: 'none'}} id='chat'>
                                                    <br/>
                                                    <GameChats userId={this.props.user.id}/>
                                                </div>
                                            </div>
                                        </p>
                                    </div>
                                </div>
                                <hr/>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-12">
                                <p className="text-muted mb-0">
                                    <div>
                                        {
                                            this.props.user.companies.length > 0 ?
                                                <NavLink to={{
                                                    pathname: '/account/' + this.props.user.id.toString() + '/register-company',
                                                }} className="btn btn-primary" style={{
                                                    float: "left"
                                                }}>
                                                    Create new company
                                                </NavLink>
                                                :<br/>
                                        }
                                    </div>
                                </p>
                            </div>
                        </div>
                        <br/>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="card mb-4 mb-md-0">
                                    <div className="card-body">
                                        {this.props.user.companies.length > 0 ?
                                            <div>
                                                <div class="table-responsive-lg" style={{
                                                    overflowX: "auto",
                                                    width: "100%",
                                                    whiteSpace: "nowrap"
                                                }}>
                                                    <table className="table table-striped table-hover">
                                                        <caption>List of your companies</caption>
                                                        <thead className="thead-light">
                                                        <tr>
                                                            <th scope="col">Name</th>
                                                            <th scope="col">Role</th>
                                                            <th scope="col">Games count</th>
                                                            <th scope="col">ES Index</th>
                                                            <th scope="col">Signature game</th>
                                                            <th scope="col">Action</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        {this.props.user.companies.map(item => (
                                                            <tr id={item.id}>
                                                                <th scope="row">{item.name}</th>
                                                                <td>Publisher</td>
                                                                <td>{item.games ? item.games.length : 0}</td>
                                                                <td>{item.games ? item.es_index : 0}</td>
                                                                <td>{item.signature_game ? item.signature_game.name : ""}</td>
                                                                <td>
                                                                    <NavLink to={{
                                                                        pathname: '/account/company/' + item.id.toString(),
                                                                        state: {companyId: item.id},
                                                                    }} className="btn btn-outline-primary">
                                                                        Manage company
                                                                    </NavLink>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                        {this.props.teamMemberCompanies.map(item => (
                                                            <tr id={item.id}>
                                                                <th scope="row">{item.name}</th>
                                                                <td>Employee</td>
                                                                <td>{item.games ? item.games.length : 0}</td>
                                                                <td>{item.games ? item.es_index : 0}</td>
                                                                <td>{item.signature_game ? item.signature_game.name : ""}</td>
                                                                <td>
                                                                    <NavLink to={{
                                                                        pathname: '/account/company/' + item.id.toString(),
                                                                        state: {companyId: item.id},
                                                                    }} className="btn btn-outline-dark">
                                                                        Work
                                                                    </NavLink>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div> : <NavLink to={{
                                                pathname: '/account/' + this.props.user.id.toString() + '/register-company',
                                            }} className="btn btn-primary" style={{
                                                float: "right"
                                            }}>
                                                Become a publisher
                                            </NavLink>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>;

        return <div>
            <Container>
                {content}
            </Container>
        </div>
    }
}

export default withRouter(Profile);
